import type { CustomerInformationType, CustomerMembershipType } from '@dtp/membership-service-types';

export enum CustomerRoleName {
  MAIN_HOUSEHOLD_MEMBER = 'MainHouseHoldMember',
  HOUSEHOLD_MEMBER = 'HouseHoldMember',
  STANDALONE_MEMBER = 'StandaloneMember',
}

export enum CustomerStatus {
  ACTIVE_MEMBERSHIP = 'ActiveMembership',
  INACTIVE_MEMBERSHIP = 'InactiveMembership',
  EXPIRED_MEMBERSHIP = 'ExpiredMembership',
}

export interface EnhancedCustomerMembershipType extends CustomerMembershipType {
  roadSideAssistance: {
    usedRoadsideAssistancesInPeriod: number;
    totalFreeRoadsideAssistancesInPeriod: number;
    isActivationPeriod?: boolean;
    activationDate?: string;
  };
}

export type CustomerMemberShip = EnhancedCustomerMembershipType & {
  paymentInterval: string;
  bindingPeriod: string;
  membershipEndDate?: string;
};

export interface RelatedCustomer {
  customerId: string;
  customerNumber: string;
  firstName: string;
  lastName: string;
  fullName: string;
  email?: string;
}

export enum ServiceStatus {
  Undefined = 0,
  IsAddedFromSubscription = 1,
  IsAddedFromService = 2,
  IsPendingCase = 3,
  CanBeAdded = 4,
  CanBeAddedByPayer = 5,
}

export enum ServiceOrigin {
  Undefined = 0,
  Subscription = 1,
  Service = 2,
  Case = 3,
  SubscriptionOffering = 4,
  BundleOffering = 5,
  ProductOffering = 6,
  NonMemberSubscriptionOffering = 7,
}

export interface Service {
  product: {
    id: string;
    name: string;
  };
  data: string;
  validUntil: string;
  signupDate: string;
  status?: string;
  endDate?: string;
  serviceStatus?: ServiceStatus;
  serviceOrigin?: ServiceOrigin;
  serviceStatusAsText?: string;
  serviceOriginAsText?: string;
}

interface SubscriptionChangeProduct {
  id: string;
  name: string;
  subscriptionLineId?: string;
}

export interface HouseHold {
  mainHouseholdCustomerId: string;
  householdCustomerName: string;
  product: {
    id: string;
    name: string;
  };
  customerRoles: string[];
  canAddHouseholdMembers: boolean;
  isPayer: boolean;
  numberOfPersonsInHousehold: number;
  relatedCustomers: RelatedCustomer[];
  householdChanges: {
    mainHouseholdCustomerId: string;
    globalChanges: {
      upgradeProducts: [];
      downgradeProducts: SubscriptionChangeProduct[];
    };
    subscriptionsChanges: {
      customerId: string;
      subscriptionId: string;
      customerName: string;
      membershipStatus: number;
      membershipStatusAsText: string;
      changeOperation: number;
      changeOperationAsText: string;
      upgradeProducts: SubscriptionChangeProduct[];
      downgradeProducts: SubscriptionChangeProduct[];
    }[];
  };
}

export interface CustomerInformationResponse {
  customerId: string;
  customerNumber: string;
  customer?: CustomerInformationType;
  membership?: CustomerMemberShip;
  numberOfPersonsInHousehold?: number;
  relatedCustomers: RelatedCustomer[];
  services: Service[];
  households: HouseHold[];
  canAddHouseholdMembers: boolean;
}
export interface MembershipInformation {
  isValid?: boolean;
  memberSince?: string;
  customerNumber?: string;
  clubName?: string;
  validUntil?: string;
}
